import { HttpContextToken } from '@angular/common/http';

// Default is true (show loading overlay)
export const SHOW_LOADING = new HttpContextToken<boolean>(() => true);
